"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSlider = void 0;
const react_1 = __importStar(require("react"));
const swiper_1 = __importStar(require("swiper"));
const react_2 = require("swiper/react");
const classnames_1 = __importDefault(require("classnames"));
const useSlides_1 = __importDefault(require("../../hooks/useSlides"));
const hi_1 = require("react-icons/hi");
const useTouchDevice_1 = require("../../hooks/useTouchDevice");
swiper_1.default.use([swiper_1.Pagination, swiper_1.Navigation]);
function ProductSlider(_a) {
    var _b;
    var { customId, id, className, title, children, backgroundColor, titleCenter, style, maxSlidesPerView = 6, slidesPerView, slidesPerGroup } = _a, props = __rest(_a, ["customId", "id", "className", "title", "children", "backgroundColor", "titleCenter", "style", "maxSlidesPerView", "slidesPerView", "slidesPerGroup"]);
    const sliderRef = (0, react_1.useRef)();
    const slides = (0, useSlides_1.default)(sliderRef, 188);
    const width = (_b = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth;
    const isMobileSmall = width && width < 480;
    const isMobileExtraSmall = width ? width <= 390 : false;
    const touchDevice = (0, useTouchDevice_1.useTouchDevice)();
    const newSwiperClass = id === null || id === void 0 ? void 0 : id.split(':').join('-').split(' ').join('-');
    return (react_1.default.createElement("div", { id: customId, className: (0, classnames_1.default)(`w-full ${isMobileExtraSmall ? 'pt-8 pb-2' : 'py-8'}`), style: Object.assign({ backgroundColor: backgroundColor ? backgroundColor : 'transparent' }, style) },
        react_1.default.createElement("div", Object.assign({ id: id, ref: sliderRef, className: (0, classnames_1.default)(`max-w-[1440px] mx-auto sm:px-4`, className) }, props),
            title && (react_1.default.createElement("h2", { className: `font-sofia font-semibold text-xl md:text-2xl mb-4 px-4 sm:px-0 lg:mb-8 ${titleCenter ? 'text-center' : ''}` }, title)),
            isMobileSmall ? (react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "flex overflow-x-auto w-full pb-6" }, react_1.default.Children.map(children, (child) => (react_1.default.createElement("div", { className: (0, classnames_1.default)('flex-shrink-0', {
                        'w-screen-60': isMobileExtraSmall,
                        'w-2/3': !isMobileExtraSmall,
                        'w-[43%]': !isMobileExtraSmall,
                    }) }, child)))))) : (react_1.default.createElement("div", { className: `main-swiper-wrap relative w-full px-4 group slidesPerView-${slidesPerView}` },
                react_1.default.createElement(react_2.Swiper, { navigation: {
                        prevEl: `#${newSwiperClass}-prev`,
                        nextEl: `#${newSwiperClass}-next`,
                    }, slidesPerView: slidesPerView
                        ? slidesPerView
                        : width && width >= 1440
                            ? maxSlidesPerView
                            : width && width >= 1140
                                ? 5
                                : width && width >= 800
                                    ? 4
                                    : slides, slidesPerGroup: slidesPerGroup
                        ? slidesPerGroup
                        : width && width >= 1440
                            ? maxSlidesPerView
                            : width && width >= 1140
                                ? 5
                                : width && width >= 800
                                    ? 4
                                    : slides, simulateTouch: false, watchOverflow: true, watchSlidesProgress: true, className: (0, classnames_1.default)('!pb-8', className) }, react_1.default.Children.map(children, (child) => (react_1.default.createElement(react_2.SwiperSlide, null, child)))),
                react_1.default.createElement("div", { className: "new-swiper-nav absolute h-0 w-full left-0 right-0 top-[30%]" },
                    react_1.default.createElement("div", { className: "new-swiper-nav-inner relative w-full" },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)('new-swiper-nav absolute left-0 bottom-0 z-10', {
                                'transition-all opacity-0 group-hover:opacity-100 focus:opacity-100': !touchDevice,
                            }) },
                            react_1.default.createElement("button", { id: `${newSwiperClass}-prev`, className: "block p-2.5 bg-white border border-e shadow-sm-all rounded-full transition-all hover:shadow-md-all text-gray hover:text-blue-hover focus:text-blue-hover disabled:hidden" },
                                react_1.default.createElement("span", { className: "sr-only" }, "Previous"),
                                react_1.default.createElement(hi_1.HiOutlineChevronLeft, { "aria-hidden": true, className: "text-3xl" }))),
                        react_1.default.createElement("div", { className: (0, classnames_1.default)('new-swiper-nav absolute right-0 bottom-0 z-10', {
                                'transition-all opacity-0 group-hover:opacity-100 focus:opacity-100': !touchDevice,
                            }) },
                            react_1.default.createElement("button", { id: `${newSwiperClass}-next`, className: "block p-2.5 bg-white border border-e shadow-sm-all rounded-full transition-all hover:shadow-md-all text-gray hover:text-blue-hover focus:text-blue-hover disabled:hidden" },
                                react_1.default.createElement("span", { className: "sr-only" }, "Next"),
                                react_1.default.createElement(hi_1.HiOutlineChevronRight, { "aria-hidden": true, className: "text-3xl" }))))))))));
}
exports.ProductSlider = ProductSlider;
